function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4409",
    viewBox: "0 0 79.374996 79.375002",
    height: 300,
    width: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-217.62499)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path829",
    style: {
      fill: "#45191c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 49.446358,228.6073 c 0,5.38974 -9.75854,29.08301 -9.75854,29.08301 0,0 -9.75911,-23.69327 -9.75911,-29.08301 0,-5.38973 4.36902,-9.75889 9.75911,-9.75889 5.38939,0 9.75854,4.36916 9.75854,9.75889"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path831",
    style: {
      fill: "#45191c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 26.023358,230.22514 c 3.81095,3.81106 13.66446,27.46517 13.66446,27.46517 0,0 -23.65453,-9.85309 -27.46551,-13.66415 -3.8108199,-3.81106 -3.8108199,-9.98996 0,-13.80102 3.81098,-3.81105 9.98981,-3.81105 13.80105,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path833",
    style: {
      fill: "#45191c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 10.604638,247.93177 c 5.38935,0 29.08318,9.75854 29.08318,9.75854 0,0 -23.69383,9.75889 -29.08318,9.75889 -5.3896599,0 -9.75898993,-4.36916 -9.75898993,-9.75889 0,-5.38939 4.36933003,-9.75854 9.75898993,-9.75854"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path835",
    style: {
      fill: "#45191c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 12.222308,271.35445 c 3.81098,-3.81071 27.46551,-13.66414 27.46551,-13.66414 0,0 -9.85351,23.6548 -13.66446,27.46516 -3.81124,3.81105 -9.99007,3.81105 -13.80105,0 -3.8108199,-3.81071 -3.8108199,-9.98961 0,-13.80102"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path837",
    style: {
      fill: "#45191c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 29.928708,286.7733 c 0,-5.38938 9.75911,-29.08299 9.75911,-29.08299 0,0 9.75889,23.69361 9.75889,29.08299 -2.7e-4,5.38974 -4.3695,9.75925 -9.75889,9.75925 -5.39009,0 -9.75911,-4.36951 -9.75911,-9.75925"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path839",
    style: {
      fill: "#45191c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 53.351958,285.15547 c -3.81106,-3.81036 -13.66414,-27.46516 -13.66414,-27.46516 0,0 23.6541,9.85343 27.46516,13.66414 3.81106,3.81141 3.81106,9.99031 0,13.80102 -3.81106,3.81105 -9.98996,3.81105 -13.80102,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path841",
    style: {
      fill: "#45191c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 68.770818,267.4492 c -5.38974,0 -29.083,-9.75889 -29.083,-9.75889 0,0 23.69326,-9.7589 29.083,-9.7589 5.38938,0 9.75854,4.36951 9.75854,9.7589 0,5.38973 -4.36916,9.75889 -9.75854,9.75889"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path843",
    style: {
      fill: "#45191c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 67.152978,244.02616 c -3.81106,3.81106 -27.46516,13.66415 -27.46516,13.66415 0,0 9.85308,-23.65446 13.66379,-27.46517 3.81141,-3.81105 9.98996,-3.81105 13.80137,0 3.81106,3.81106 3.81106,9.98996 0,13.80102"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path845",
    style: {
      fill: "#f4a3ad",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 59.023918,246.70939 c -2.37349,2.42641 -17.19897,8.79546 -17.19897,8.79546 0,0 6.0392,-14.96307 8.41269,-17.38948 2.37278,-2.42605 6.26357,-2.46909 8.68962,-0.0963 2.42641,2.37349 2.46944,6.26392 0.0967,8.69033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path847",
    style: {
      fill: "#f4a3ad",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 45.595428,236.25306 c 0.0374,3.39372 -5.94183,18.38007 -5.94183,18.38007 0,0 -6.31049,-14.85018 -6.34788,-18.2439 -0.0374,-3.39337 2.68287,-6.17502 6.07659,-6.21277 3.39408,-0.0381 6.17538,2.68252 6.21312,6.0766"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path849",
    style: {
      fill: "#f4a3ad",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 28.706548,238.35455 c 2.42606,2.37279 8.79511,17.19827 8.79511,17.19827 0,0 -14.96322,-6.03885 -17.38899,-8.41198 -2.42672,-2.37349 -2.46944,-6.26357 -0.0965,-8.68998 2.37296,-2.4264 6.26385,-2.46944 8.69033,-0.0963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path851",
    style: {
      fill: "#f4a3ad",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 18.249578,251.78269 c 3.39411,-0.0378 18.38071,5.94219 18.38071,5.94219 0,0 -14.8506,6.30943 -18.24429,6.34753 -3.39368,0.0374 -6.17456,-2.68323 -6.21262,-6.0766 -0.0379,-3.39372 2.68276,-6.17573 6.0762,-6.21312"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path853",
    style: {
      fill: "#f4a3ad",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 20.351078,268.67157 c 2.373,-2.4257 17.19855,-8.7951 17.19855,-8.7951 0,0 -6.03885,14.96307 -8.41191,17.38912 -2.37324,2.4264 -6.26347,2.46909 -8.68991,0.096 -2.4263,-2.37278 -2.46972,-6.26321 -0.0967,-8.68997"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path855",
    style: {
      fill: "#f4a3ad",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 33.779848,279.12826 c -0.0377,-3.39408 5.94148,-18.38043 5.94148,-18.38043 0,0 6.31049,14.85018 6.34789,18.24425 0.0377,3.39337 -2.68323,6.17467 -6.0766,6.21242 -3.39337,0.0381 -6.17538,-2.68217 -6.21277,-6.07624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path857",
    style: {
      fill: "#f4a3ad",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 50.669078,277.02711 c -2.4264,-2.37349 -8.7958,-17.19827 -8.7958,-17.19827 0,0 14.96306,6.0385 17.38912,8.41164 2.4264,2.37313 2.46909,6.26321 0.096,8.68962 -2.37243,2.42605 -6.26321,2.46979 -8.68927,0.097"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path859",
    style: {
      fill: "#f4a3ad",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 61.125068,263.59827 c -3.39373,0.0378 -18.38008,-5.94183 -18.38008,-5.94183 0,0 14.85018,-6.31014 18.2439,-6.34788 3.39408,-0.0374 6.17467,2.68322 6.21242,6.07695 0.0378,3.39336 -2.68217,6.17537 -6.07624,6.21276"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path861",
    style: {
      fill: "#a76d74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.700788,241.28861 c -0.0437,2.61726 -4.97381,14.04408 -4.97381,14.04408 0,0 -4.54766,-11.58416 -4.50427,-14.20177 0.0441,-2.61691 2.20063,-4.70359 4.81789,-4.6602 2.61761,0.0437 4.70358,2.20098 4.66019,4.81789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path863",
    style: {
      fill: "#a76d74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 31.634958,242.54838 c 1.81963,1.88101 6.41315,13.44683 6.41315,13.44683 0,0 -11.40697,-4.97558 -13.22666,-6.85659 -1.8197,-1.88172 -1.76968,-4.88209 0.11161,-6.70207 1.88144,-1.82034 4.88171,-1.76989 6.7019,0.11183"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path865",
    style: {
      fill: "#a76d74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 23.285868,252.67733 c 2.61733,0.0437 14.04398,4.97382 14.04398,4.97382 0,0 -11.58444,4.54766 -14.20131,4.50391 -2.61762,-0.0434 -4.7037,-2.20063 -4.66013,-4.81753 0.0433,-2.61761 2.20031,-4.70359 4.81746,-4.6602"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path867",
    style: {
      fill: "#a76d74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 24.545148,265.74352 c 1.88143,-1.82034 13.44757,-6.41386 13.44757,-6.41386 0,0 -4.97558,11.40707 -6.85729,13.22705 -1.88154,1.81963 -4.88153,1.76953 -6.70162,-0.11148 -1.82026,-1.88136 -1.76971,-4.88209 0.11134,-6.70171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path869",
    style: {
      fill: "#a76d74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 34.674848,274.092 c 0.0434,-2.6169 4.97346,-14.04373 4.97346,-14.04373 0,0 4.54766,11.58416 4.50426,14.20142 -0.0437,2.61726 -2.20062,4.70288 -4.81788,4.6602 -2.61691,-0.0437 -4.70323,-2.20063 -4.65984,-4.81789"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path871",
    style: {
      fill: "#a76d74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 47.740678,272.83294 c -1.81998,-1.88172 -6.41386,-13.44754 -6.41386,-13.44754 0,0 11.40707,4.97558 13.22705,6.8573 1.81998,1.88136 1.76954,4.88173 -0.11148,6.70101 -1.88136,1.82033 -4.88208,1.77059 -6.70171,-0.11077"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path873",
    style: {
      fill: "#a76d74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 56.089158,262.70363 c -2.61725,-0.0437 -14.04373,-4.97381 -14.04373,-4.97381 0,0 11.58417,-4.54766 14.20142,-4.50427 2.61726,0.0434 4.70324,2.20063 4.6602,4.81753 -0.0438,2.61726 -2.20063,4.70394 -4.81789,4.66055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path875",
    style: {
      fill: "#a76d74",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 54.830098,249.63709 c -1.88137,1.82069 -13.44718,6.41386 -13.44718,6.41386 0,0 4.97557,-11.40672 6.85659,-13.2267 1.88206,-1.81998 4.88209,-1.76953 6.70171,0.11148 1.81998,1.88136 1.7706,4.88174 -0.11112,6.70136"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path877",
    style: {
      fill: "#341a1a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.190318,258.32213 c 0,2.75908 -2.23661,4.99639 -4.99604,4.99639 -2.75942,0 -4.99639,-2.23731 -4.99639,-4.99639 0,-2.75943 2.23697,-4.99639 4.99639,-4.99639 2.75943,0 4.99604,2.23696 4.99604,4.99639"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower1);
export default __webpack_public_path__ + "static/media/flower-1.0315a7571957ba2aaa8b2b7431f51302.svg";
export { ForwardRef as ReactComponent };